export default __webpack_public_path__ + "static/media/price_unavailable.62205e88.png";